import { useEffect, useRef } from "react";
import QRCode from "qrcode";

// A QR code for a family link, drawn to a canvas so it prints sharp. With no URL it leaves the
// space blank for the teacher to fill in, so the card still prints right.
export function LaunchQR({ url }: { url?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (!url || !ref.current) return;
    void QRCode.toCanvas(ref.current, url, { margin: 1, width: 150, color: { dark: "#041E42", light: "#FFFFFF" } }).catch(() => {});
  }, [url]);
  if (!url) {
    return (
      <div className="launch-qr blank">
        <span>Ask your teacher for the link</span>
      </div>
    );
  }
  return (
    <div className="launch-qr">
      <canvas ref={ref} role="img" aria-label="QR code for the family link" />
    </div>
  );
}
